import React from "react";
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorWrapper } from "../styles";

type Props = {
  editorState: EditorState;
  onChange?: (editorState: EditorState) => void;
  className?: string;
  showErrorBorder?: boolean;
};
const EditorR = Editor as any;
class DraftEditor extends React.Component<Props> {
  private editor: React.RefObject<Editor> = React.createRef();

  render(): React.ReactNode {
    const { editorState, onChange, className, showErrorBorder } = this.props;

    const errorClass = showErrorBorder ? "error-border" : "";
    return (
      <EditorWrapper>
        <EditorR
          ref={this.editor}
          editorState={editorState}
          wrapperClassName={`editor-wrapper ${className} ${errorClass}`}
          editorClassName="custom-editor"
          onEditorStateChange={(value: any) => onChange?.(value)}
        />
      </EditorWrapper>
    );
  }
}
export default DraftEditor;
